import { render, staticRenderFns } from "./NotificationsEditor.vue?vue&type=template&id=2596568e&"
import script from "./NotificationsEditor.vue?vue&type=script&lang=ts&"
export * from "./NotificationsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsEditor.vue?vue&type=style&index=0&id=2596568e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports